/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Actions_ViewInputs */

const es_feedback_actions_view = /** @type {(inputs: Feedback_Actions_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver detalles`)
};

const en_feedback_actions_view = /** @type {(inputs: Feedback_Actions_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View details`)
};

/**
* | output |
* | --- |
* | "View details" |
*
* @param {Feedback_Actions_ViewInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_actions_view = /** @type {((inputs?: Feedback_Actions_ViewInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Actions_ViewInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_actions_view(inputs)
	return en_feedback_actions_view(inputs)
});
export { feedback_actions_view as "feedback.actions.view" }